import { useNavigate } from 'react-router-dom';
import useAuth from '../../utils/hooks/useAuth';
import LoginForm from './LoginForm';

const LoginPage = () => {
  const {
    error,
    setError,
    onLoginWithEmailAndPassword,
    onLoginWithGoogle,
    isLoading
  } = useAuth();

  const navigate = useNavigate();

  const checkSupportedDevice = (functionLogin, args) => {
    functionLogin(args);
  };

  return (
    <LoginForm
      error={error}
      setError={setError}
      isLoading={isLoading}
      onLoginWithGoogle={(credentials) => {
        checkSupportedDevice(onLoginWithGoogle, credentials);
      }}
      onLoginWithEmailAndPassword={(credentials) => {
        checkSupportedDevice(onLoginWithEmailAndPassword, credentials);
      }}
    />
  );
};

export default LoginPage;
